import { Navigate, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api/client.js";
import type { Ruolo } from "@taras/contracts";

interface MeResponse {
  ruolo: Ruolo;
}

interface Props {
  role: Ruolo;
}

export function RequireRole({ role }: Props) {
  const { data } = useQuery<MeResponse>({
    queryKey: ["auth", "me"],
    queryFn: () => apiClient.get<MeResponse>("/api/v1/auth/me"),
    retry: false,
  });

  if (data?.ruolo !== role && data?.ruolo !== "ADMIN") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
